export const formatCommentDate = (commentDate: string): string => {
    const commentDateTime = new Date(commentDate).getTime();
    const now = new Date().getTime();
    const differenceInTime = now - commentDateTime; // in milliseconds
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    if (differenceInDays < 1) {
        // Less than 1 day
        const differenceInHours = Math.floor(differenceInTime / (1000 * 3600));
        if (differenceInHours < 1) {
            // Less than 1 hour
            const differenceInMinutes = Math.floor(differenceInTime / (1000 * 60));
            return differenceInMinutes <= 1 ? 'لحظاتی پیش' : `${differenceInMinutes} دقیقه پیش`;
        }
        return `${differenceInHours} ساعت پیش`;
    } else if (differenceInDays < 2) {
        return 'دیروز';
    } else {
        // Format the date to a more readable form, adjust according to your locale
        return new Intl.DateTimeFormat('fa-IR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }).format(new Date(commentDate));
    }
};
